/**
 * Variant Cular - Image-based Variant Picker
 * Handles variant selection with image previews
 * Uses Shopify's built-in VariantSelects web component
 */

// The variant-cular uses Shopify's existing VariantSelects web component
// which automatically handles all variant logic. We just need to ensure
// our custom styling and image display works with it.

document.addEventListener('DOMContentLoaded', () => {
  const variantCulars = document.querySelectorAll('.variant-cular');
  
  variantCulars.forEach(container => {
    const inputs = container.querySelectorAll('.variant-cular__input');
    
    // Update selected value display when variant changes
    inputs.forEach(input => {
      input.addEventListener('change', () => {
        if (input.checked) {
          const fieldset = input.closest('fieldset');
          const selectedValueSpan = fieldset.querySelector('[data-selected-value]');
          if (selectedValueSpan) {
            selectedValueSpan.textContent = input.value;
          }
        }
      });
    });
  });
});
